import { render, staticRenderFns } from "./uploader.template?vue&type=template&id=9bdb7c18&scoped=true&lang=pug&"
import script from "./uploader.client?vue&type=script&lang=ts&"
export * from "./uploader.client?vue&type=script&lang=ts&"
import style0 from "./uploader.style?vue&type=style&index=0&id=9bdb7c18&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bdb7c18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/flypaper/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9bdb7c18')) {
      api.createRecord('9bdb7c18', component.options)
    } else {
      api.reload('9bdb7c18', component.options)
    }
    module.hot.accept("./uploader.template?vue&type=template&id=9bdb7c18&scoped=true&lang=pug&", function () {
      api.rerender('9bdb7c18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/attachments/uploader/uploader.component.vue"
export default component.exports